import React, { useEffect } from "react";
import VeriffModule from "@veriff/js-sdk";
import GenericApi from "@/api/genericApi.tsx";
import { ApiRoutes } from "@/config/routes/ApiRoutes.tsx";
import { getUser } from "@/utils/localStorage.tsx";

export interface VeriffSessionResponse {
  status: "success";
  verification: {
    id: string;
    url: string;
    host: string;
    status: string;
    sessionToken: string;
  };
}

type Options = {
  apiKey: string;
  parentId: string;
  onSession: (err: unknown, response: VeriffSessionResponse) => void;
};

type MountOptions = {
  formLabel?: {
    title?: string;
    description?: string;
  };
  loadingText?: string;
  submitBtnText?: string;
};

type Params = {
  sessionToken: string;
  parentId: string;
  onSession: (err: unknown, response: VeriffSessionResponse) => void;
};

type UserIdParams = {
  vendorData: string;
};

type VeriffFunction = (options: Options) => {
  params: Params;
  setParams: (newParams: Params | UserIdParams) => void;
  mount: (mountOptions?: MountOptions) => void;
};

const getVeriffApiKey = (): string => {
  const host = window.location.host;
  if (host === "leonext.exchange") {
    return "52a3982a-8ec0-4ad4-b3cb-cd0d939e4650";
  }
  return "9354a344-cda9-416d-9f91-2e7341fc8743";
};

const VeriffPage: React.FC = () => {
  const user = getUser();

  useEffect(() => {
    const Veriff = (VeriffModule as unknown as { Veriff: VeriffFunction })
      .Veriff;
    const veriff = Veriff({
      //   apiKey: import.meta.env.VITE_VERIFF_API_KEY,
      apiKey: getVeriffApiKey(),
      parentId: "veriff-root",
      onSession: (err: unknown, response: VeriffSessionResponse) => {
        if (err) {
          console.error("Veriff session error:", err);
        } else {
          console.log("Veriff session response:", response);
          if (response.status === "success") {
            GenericApi.post(ApiRoutes.VERRIFF_SESSION, {
              ...response,
              user_id: user?.id,
            })
              .then((res) => {
                console.log("Veriff session saved successfully:", res);
                window.location.href = response.verification.url;
              })
              .catch((error) => {
                console.error("API error while saving Veriff session:", error);
              });
          }
        }
      },
    });

    // veriff.mount(
    //     {
    //         formLabel: {
    //             title: 'Verify Your Identity',
    //             description: 'Please complete the verification process to continue.',
    //         },
    //         loadingText: 'Loading verification...',
    //         submitBtnText: 'Start Verification',
    //     }
    // );

    veriff.setParams({
      vendorData: String(user?.id) ?? "",
    });
    veriff.mount({
      submitBtnText: "Start Verification",
    });

    return () => {
      const el = document.getElementById("veriff-root");
      if (el) {
        el.innerHTML = "";
      }
    };
  }, []);

  return <div id="veriff-root"></div>;
};

export default VeriffPage;
